// extracted by mini-css-extract-plugin
export default {"overlay":"AudioAlertProvider_overlay__xfIlR","card":"AudioAlertProvider_card__7Pf0V","title":"AudioAlertProvider_title__i+FG8","description":"AudioAlertProvider_description__0V53s"};